import { Steps } from 'antd';
import { filterPermittedLinks } from 'components/NavigationMenu/links';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { LoginPageWrapper } from 'pages/LoginPage/style';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RecoveryPhoneForm } from './RecoveryPhoneForm';
import { RecoveryCodeForm } from './RecoveryCodeForm';
import { RecoveryPasswordForm } from './RecoveryPasswordForm';

function RecoveryPage() {
  useDocumentTitle('Воссстановление пароля | Payda');
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  const [currentStep, setCurrentStep] = useState(0);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    phone: '',
  });

  useEffect(() => {
    if (isLoggedIn) {
      navigate(getFirstPath());
    }
  }, [isLoggedIn, navigate]);

  const getFirstPath = () => {
    let path = '';

    if (user) {
      const permittedLinks = filterPermittedLinks(user);

      if (permittedLinks.length) {
        const link = permittedLinks[0];

        if (link.sublinks && link.sublinks?.length) {
          path = link.sublinks[0].path;
        } else {
          path = link.path;
        }
      }
    }

    return path;
  };

  return (
    <LoginPageWrapper>
      <div className="logo-section">
        <img src="./assets/icons/logo/payda-lg-white.svg" alt="Payda logo" />
      </div>

      <div className="login-section">
        <div>
          <Steps current={currentStep}>
            <Steps.Step title="Номер телефона" />
            <Steps.Step title="Проверка кода" />
            <Steps.Step title="Сменить пароль" />
          </Steps>
          {currentStep === 0 && (
            <RecoveryPhoneForm
              setCurrentStep={setCurrentStep}
              setFormData={setFormData}
              formData={formData}
            />
          )}
          {currentStep === 1 && (
            <RecoveryCodeForm
              setCurrentStep={setCurrentStep}
              setFormData={setFormData}
              formData={formData}
            />
          )}
          {currentStep === 2 && (
            <RecoveryPasswordForm
              setCurrentStep={setCurrentStep}
              setFormData={setFormData}
              formData={formData}
            />
          )}
        </div>
      </div>
    </LoginPageWrapper>
  );
}

export { RecoveryPage };
